const dateTimeFormat = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
});

// use ISO 8601 formatted date string e.g: "2022-07-15T19:41:01.395Z"
export default function areDatesEqual(
    date1String: string,
    date2String: string
): boolean {
    // compares two dates for differences upto minute, seconds difference are ignored
    const date1 = dateTimeFormat.format(new Date(date1String));
    const date2 = dateTimeFormat.format(new Date(date2String));

    return date1 === date2;
}
